import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { push } from 'react-router-redux';
import clone from 'clone';
import {
  Container,
  Dimmer,
  Grid,
  Loader,
  Divider,
  Header,
  Label,
  Button,
} from 'semantic-ui-react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import config from '../../../config';
import LPPSAChecker from '../../components/LPPSAChecker';
import { fetchM } from '../../actions/fetchM';
import { flashErrorMessage } from '../../actions/flash';
import { bookingFlow } from '../../utils/routes';

const isPRS = config.get('prs');

class LPPSA extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }
  static propTypes = {
    token: PropTypes.string,
    fetchNewBooking: PropTypes.func,
    loading: PropTypes.bool,
  }
  static defaultData = {
    id: '',
    customer: {
      id: '',
      lppsaResultStatusID: '',
      lppsaResultID: '',
      lppsaResult: {
        name: '',
        key: '',
      },
    },
  };
  static mapStateToProps = () => ({})
  static getPropsToState = (props) => {
    const loading = props.loading;
    const data = Object.assign({}, LPPSA.defaultData, props.data);
    return {
      loading,
      data,
      oriData: clone(data),
    };
  }
  constructor(props) {
    super(props);
    const state = LPPSA.getPropsToState(props);
    this.state = {
      ...state,
    };
    this.validation = {};
  }
  componentWillReceiveProps(nextProps) {
    const state = LPPSA.getPropsToState(nextProps);
    // don't allow state to override data if oriData is same
    if (JSON.stringify(this.state.oriData) === JSON.stringify(state.oriData)) {
      state.data = this.state.data;
    }
    this.setState({ ...state });
  }
  setLoading = (loading = false) => (
    new Promise((res) => {
      this.setState({ loading }, res);
    })
  )
  async updateForm(customerData) {
    const data = customerData;
    delete data.lppsaResult;
    delete data.customerDetail;
    await this.setLoading(true);
    const { store } = this.context;
    try {
      await store.dispatch(fetchM(`/bookings/${this.state.data.id}/customer/${data.id}/`, {
        credentials: 'include',
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': this.props.token,
        },
        body: JSON.stringify(data),
      }));
    } catch (err) {
      await this.setLoading(false);
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
        return;
      }
      Bugsnag.notifyException(err);
      store.dispatch(flashErrorMessage({ message: 'There was an error with your request. Please try again.' }));
      return;
    }
    await this.setLoading(false);
    store.dispatch(push(bookingFlow(this.state.data, 1)));
  }
  handleOnSave = (e) => {
    e.preventDefault();
    const { data } = this.state;
    this.updateForm(data.customer);
  }
  handleOnChange = (customerData) => {
    const { data } = this.state;
    data.customer = Object.assign({}, data.customer, customerData);
    this.setState({ data });
  }
  render() {
    const { data } = this.state;
    const projectUnit = data.projectUnit;
    const project = data.project;
    return (
      <Container>
        <Grid>
          <Dimmer style={{ zIndex: 20 }} active={this.state.loading} inverted>
            <Loader inline="centered">Loading</Loader>
          </Dimmer>
          <Grid.Row>
            <Grid.Column width={16} textAlign="center">
              <Header as="h4" textAlign="center">
                Booking for <br className="large-hide small-hide tablet-hide" /><Link to={`/projects/${project && project.id}/units/${projectUnit && projectUnit.id}/`}>{projectUnit && projectUnit.reference}</Link>, {project && project.name} {projectUnit && projectUnit.isBumi && <Label size="mini">Bumi</Label>}
              </Header>
              <LPPSAChecker
                newHeader="CUSTOMER ASSESSMENT"
                bookingID={data.id}
                data={data.customer || {}}
                token={this.props.token}
                type="booking"
                loading={this.state.loading}
                onChange={this.handleOnChange}
              />
              <Button
                positive
                size="large"
                onClick={this.handleOnSave}
                style={{ margin: '1em 0 0.5em' }}
              >
                Save and Continue
              </Button>
              {/* <p><Link to={bookingFlow(data, 1)}>Skip this step</Link></p> */}
              {!isPRS && <p><Link to={bookingFlow(data, 1)}>Skip this step</Link></p>}
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Container>
    );
  }
}

export default connect(LPPSA.mapStateToProps)(LPPSA);




// WEBPACK FOOTER //
// ./src/containers/Bookings/LPPSA.jsx